import { createAction } from 'redux-api-middleware'
import qs from 'query-string'
import { HUBBLE_API_TOKEN } from '../store/middleware/APIUrl'
import { DateUtils } from '../utils'

const Types = {
    REPORT_DEVICES: {
        request: 'REPORT_DEVICES##REQUEST',
        success: 'REPORT_DEVICES##SUCCESS',
        failure: 'REPORT_DEVICES##FAILURE',
    },
    REPORT_STORE_NOTES: {
        request: 'REPORT_STORE_NOTES##REQUEST',
        success: 'REPORT_STORE_NOTES##SUCCESS',
        failure: 'REPORT_STORE_NOTES##FAILURE',
    },
}

/**
 * Reads binary body from a fetch response and converts it into a Blob
 * @param {Object} action
 * @param {Object} state
 * @param {Object} res Fetch response
 */
async function binaryPayloadToBlob(action, state, res) {
    const { body } = res
    // eslint-disable-next-line no-bitwise
    if (!(body instanceof ReadableStream)) {
        return
    }

    // Get reader from stream
    const reader = body.getReader()

    // Read from stream
    const stream = await new ReadableStream({
        start(controller) {
            function pump() {
                return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close()
                        return
                    }

                    controller.enqueue(value)
                    return pump()
                })
            }
            return pump()
        },
    })

    return new Response(stream).blob()
}

/**
 * Get devices report
 * @param {Object} options
 * @param {String} options.migrationStatus
 * @param {Bool} options.withMigrationStatus
 */
function reportDevices({ migrationStatus, withMigrationStatus }) {
    const endpoint = qs.stringifyUrl(
        {
            url: `${HUBBLE_API_TOKEN}/reports/devices`,
            query: {
                migrated: withMigrationStatus ? migrationStatus : null,
            },
        },
        {
            skipNull: true,
        }
    )

    return createAction({
        endpoint,
        method: 'GET',
        types: [
            Types.REPORT_DEVICES.request,
            {
                type: Types.REPORT_DEVICES.success,
                payload: binaryPayloadToBlob,
            },
            Types.REPORT_DEVICES.failure,
        ],
    })
}

/**
 * Get store notes report
 * @param {Number} [from]
 * @param {Number} [to]
 */
function reportStoreNotes(from, to) {
    const endpoint = qs.stringifyUrl({
        url: `${HUBBLE_API_TOKEN}/reports/store_notes`,
        query: {
            from: DateUtils.formatDB(from),
            to: DateUtils.formatDB(to),
        },
    })

    return createAction({
        endpoint,
        method: 'GET',
        types: [
            Types.REPORT_STORE_NOTES.request,
            {
                type: Types.REPORT_STORE_NOTES.success,
                payload: binaryPayloadToBlob,
            },
            Types.REPORT_STORE_NOTES.failure,
        ],
    })
}

export { Types, reportDevices, reportStoreNotes }
